<form [formGroup]="berekeningPGAFormGroup">
    <div class="row">
        <ng-container formGroupName="opbouwPGA">
            <snelstart-ui-number-form-control formControlName="specifiekeZorgkosten"
                                              id=" specifiekeZorgkosten"
                                              label="specifiekeZorgkosten"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="aftrekbareGiften"
                                              id="aftrekbareGiften"
                                              label="aftrekbareGiften"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="scholingsuitgaven"
                                              id="scholingsuitgaven"
                                              label="scholingsuitgaven"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="onderhoudsverplichtingen"
                                              id=" onderhoudsverplichtingen"
                                              label="onderhoudsverplichtingen"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="weekenduitgaven"
                                              id="weekenduitgaven"
                                              label="weekenduitgaven"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="restantPgaVoorgaandeJaren"
                                              id=" restantPgaVoorgaandeJaren"
                                              label="restantPgaVoorgaandeJaren"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="monumentenpanden"
                                              id="monumentenpanden"
                                              label="monumentenpanden"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="kwijtscheldingDurfkapitaal"
                                              id="kwijtscheldingDurfkapitaal"
                                              label="kwijtscheldingDurfkapitaal"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control formControlName="aandeelPartnerPga"
                                              id="aandeelPartnerPga"
                                              label="aandeelPartnerPga"
                                              class="me-4 custom-input-150"
                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                              align="right"
            ></snelstart-ui-number-form-control>
        </ng-container>

    </div>
</form>
